<template>
    <button class="heading__left_menu_burger" @click.prevent="clickMenu">
        <svg width="24" height="24">
            <use xlink:href="/icons/base.svg#menu_burger"></use>
        </svg>
    </button>
</template>

<script>
import {getStateMenu, setStateMenu} from "../../helpers/menuState";
export default {
    name: "burger_menu",
    methods: {
        clickMenu() {
            EventBus.$emit('open_menu');
        },
    },
}
</script>
